import styled from 'styled-components';
import { getStyle as getCheckBoxStyles } from '@ids/ddms-styled/comps/checkbox/intuit/light';

const disabledColor = 'rgba(0, 0, 0, 0.25)';
const theme = {
  intuit: {
    color: '#0077c5',
    hoverColor: '#0077c5'
  },
  quickbooks: {
    color: '#53b700', // green03
    hoverColor: '#2CA01C', // green02
    disabledColor: '#393a3d'
  },
  mint: {
    color: 'rgb(0,193,191)',
    hoverColor: 'rgb(0,193,191)'
  },
  proconnect: {
    color: 'rgb(0,119,197)',
    hoverColor: 'rgb(0,119,197)'
  },
  turbotax: {
    color: 'rgb(5,164,181)',
    hoverColor: 'rgb(5,164,181)'
  }
};

// Theme based Hover
// Disabled
export const WrapperSpan = styled.span`
  color: ${getCheckBoxStyles('choiceText.color')};
  font-weight: 400;
  font-size: ${getCheckBoxStyles('choiceText.fontSize')};
  line-height: ${getCheckBoxStyles('choiceText.lineHeight')};
  opacity: 1;
  padding-left: 8px;
  padding-right: 8px;
  margin-left: 18px;
  display: block;

  ${props =>
    props.theme &&
    `
    &:hover span:first-of-type {
      border-color: ${theme[props.theme].color};
    };
  `};

  ${props =>
    props.disabled &&
    `
    color: ${
      props.theme === 'quickbooks'
        ? theme[props.theme].disabledColor
        : disabledColor
    } ;
    cursor: not-allowed;
  `};
`;

// Theme based Hover
export const Label = styled.label`
  cursor: pointer;
  font-size: ${getCheckBoxStyles('choiceText.fontSize')};
  display: inline-block;
  margin-bottom: 20px;

  ${props =>
    props.theme &&
    `
    &:hover span:first-of-type {
      border-color: ${theme[props.theme].hoverColor};
    };
  `};

  &:not(:last-child) {
    margin-right: 8px;
  }

  ${props => props.disabled && `pointer-events:none;`};
`;

// ${getCheckBoxStyles('choiceText.fontSize')};
// DD will be changing to 1.4rem
// font color now consistent with label #6b6c72
export const Legend = styled.legend`
  color: #6b6c72;
  font-size: 14px;
  padding-left: 0;
  margin-bottom: 20px;
`;

export const CheckBoxGroupFieldset = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
  ${props =>
    props.vertical &&
    `
    display: flex;
    flex-direction: column;
  `};
`;

export const CheckBoxGroupDiv = styled.div`
  border: 0;
  margin: 0;
  padding: 0;
  ${props =>
    props.vertical &&
    `
    display: flex;
    flex-direction: column;
  `};
`;
